export interface IEducation {
  value: string;
  label: string;
}

export const NANO_DEGREE = 'Nanodegree';
export const NO_DEGREE = 'No Degree';
export const COMPUTER_ENGINEERING = 'Computer Engineering';

export const degrees: Array<IEducation> = [
  {value: 'BA', label: 'B.A.'},
  {value: 'BSC', label: 'B.Sc.'},
  {value: 'BEng', label: 'B.Eng.'},
  {value: 'Nano', label: NANO_DEGREE},
  {value: 'MA', label: 'M.A.'},
  {value: 'MSC', label: 'M.Sc.'},
  {value: 'MENG', label: 'M.Eng.'},
  {value: 'PHD', label: 'Ph.D.'},
];

export const educationStatus: Array<IEducation> = [
    {value: 'STUDENT', label: 'Student'},
    {value: 'GRAD', label: 'Graduate'},
    {value: 'NO_DEGREE', label: NO_DEGREE},
];

export const studyAreas: Array<IEducation> = [
  {value: 'CS', label: 'Computer Science'},
  {value: 'SYMB_SYS', label: 'Symbolic Systems'},
  {value: 'COMP_ENG', label: COMPUTER_ENGINEERING},
  {value: 'MATH', label: 'Mathematics'},
  {value: 'STAT', label: 'Statistics'},
  {value: 'INFO_SYS', label: 'Information Systems / M.I.S.'},
  {value: 'IND_ENG', label: 'Other Engineering'},
  {value: 'OTHER_SCI', label: 'Other Exact Sciences Degree'},
  {value: 'OTHER_TECH', label: 'Other Technology Related Degree'},
  {value: 'OTHER', label: 'Any Other Degree'},
];
